import { IconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const RollbackIcon: FC<IconProps> = memo(
  ({ size, width, height, ...props }) => {
    const { rpx } = useResponsiveContext();
    size = size ?? rpx(64);
    return (
      <Svg
        viewBox="0 0 1024 1024"
        width={width ?? size}
        height={height ?? size}
        {...props}
      >
        <Path
          d="M512 1024c281.6 0 512-89.6 512-512S793.6 0 512 0 0 89.6 0 512s230.4 512 512 512z"
          fill="#FF6666"
        />
        <Path
          d="M665.6 256c56.32 0 102.4 46.08 102.4 102.4v174.08c-23.04-12.8-48.64-20.48-76.8-20.48-84.48 0-153.6 69.12-153.6 153.6 0 38.4 15.36 74.24 38.4 102.4H358.4c-56.32 0-102.4-46.08-102.4-102.4V358.4c0-56.32 46.08-102.4 102.4-102.4h307.2z m-179.2 256h-102.4c-15.36 0-25.6 10.24-25.6 25.6 0 12.8 10.24 23.04 23.04 25.6H486.4c15.36 0 25.6-10.24 25.6-25.6s-10.24-25.6-25.6-25.6z m153.6-128H384c-15.36 0-25.6 10.24-25.6 25.6 0 12.8 10.24 23.04 23.04 25.6H640c15.36 0 25.6-10.24 25.6-25.6s-10.24-25.6-25.6-25.6z"
          fill="#FFFFFF"
        />
        <Path
          d="M691.2 665.6m-153.6 0a153.6 153.6 0 1 0 307.2 0 153.6 153.6 0 1 0-307.2 0Z"
          fill="#FFFFFF"
          fillOpacity=".5"
        />
        <Path
          d="M762.88 742.4c-10.24-28.16-35.84-48.64-66.56-48.64H691.2V640h5.12c38.4 0 71.68 33.28 71.68 74.24 0 10.24-2.56 20.48-5.12 28.16z m-89.6-5.12l-53.76-61.44c-2.56-2.56-5.12-5.12-5.12-10.24s2.56-7.68 2.56-10.24l53.76-61.44c5.12-5.12 17.92-5.12 17.92 0v145.92c0 2.56-10.24 5.12-15.36-2.56z"
          fill="#FFFFFF"
        />
      </Svg>
    );
  },
);
